writeToStore